import { render } from "./Footer.html?vue&type=template&id=51c08030&scoped=true&ts=true"
import script from "./Footer.ts?vue&type=script&lang=ts"
export * from "./Footer.ts?vue&type=script&lang=ts"

import "./Footer.scss?vue&type=style&index=0&id=51c08030&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c08030"]])

export default __exports__